import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const ModalButtonGroup = styled.div`
  display: flex;
  justify-content: space-between;
  text-align: center;
  ${({ theme }) => theme.ModalButtonGroup}
`;

const ModalButton = styled.span`
  flex-grow: 1;
  padding: 10px;
  box-sizing: border-box;
  cursor: pointer;
  overflow: hidden;
  position: relative;
  line-height: 24px;
  text-align: center;
  text-overflow: ellipsis;
  letter-spacing: 0;
  -webkit-tap-highlight-color: transparent;
  ${({ highlight, theme }) => `
    border-radius: ${theme.buttonRadius};
    font: 16px ${theme.fontSemibold};
    ${
      highlight
        ? `
      background: ${theme.fitbitMidnight};
      color: #fff;
    `
        : `
      background: #fff;
      color: ${theme.fitbitMidnight};
    `
    }
  `}
`;

const ModalButtonAnchor = styled.a`
  flex-grow: 1;
  padding: 10px;
  box-sizing: border-box;
  cursor: pointer;
  overflow: hidden;
  position: relative;
  line-height: 24px;
  text-align: center;
  text-overflow: ellipsis;
  text-decoration: none;
  letter-spacing: 0;
  -webkit-tap-highlight-color: transparent;
  ${({ highlight, theme }) => `
    border-radius: ${theme.buttonRadius};
    font: 16px ${theme.fontSemibold};
    ${
      highlight
        ? `
      background: ${theme.fitbitMidnight};
      color: #fff;
    `
        : `
      background: #fff;
      color: ${theme.fitbitMidnight};
    `
    }
  `}
`;

const ButtonGroup = ({ buttons }) => (
  <ModalButtonGroup>
    {buttons.map(
      ({
        highlight,
        text,
        onClick,
        testType = undefined,
        id = undefined,
        isAnchor,
        href
      }) =>
        isAnchor ? (
          <ModalButtonAnchor
            highlight={highlight}
            href={href}
            onClick={onClick}
            key={text}
            data-test-type={testType}
            id={id}
            aria-label={id}
          >
            {text}
          </ModalButtonAnchor>
        ) : (
          <ModalButton
            highlight={highlight}
            onClick={onClick}
            key={text}
            data-test-type={testType}
            id={id}
            aria-label={id}
          >
            {text}
          </ModalButton>
        )
    )}
  </ModalButtonGroup>
);

ButtonGroup.propTypes = {
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      highlight: PropTypes.bool,
      text: PropTypes.oneOfType([
        PropTypes.string.isRequired,
        PropTypes.element.isRequired
      ]),
      onClick: PropTypes.func.isRequired,
      isAnchor: PropTypes.bool,
      href: PropTypes.string
    })
  )
};

export default ButtonGroup;
